<template>
  <div class="_lvp">
    <div class="_p" v-if="$store.state.screenWidth > 960">
      <div class="_center">
        <div class="_header">
          <h5>建筑全生命期可视化管理平台</h5>
          <span>HBIM LVP</span>
        </div>
        <div class="_des">
          <ul>
            <li>以项目为核心</li>
            <li>连接项目各参建方</li>
            <li>共享项目数据</li>
            <li>即时沟通 高效协同</li>
          </ul>
          <div class="_btn" @click="$router.push('/product/lvp')">了解更多</div>
        </div>
        <div class="_lvp_img_bg">
          <div
            class="_img"
            :style="{ backgroundImage: 'url(' + activeImg + ')' }"
          ></div>
        </div>
        <!-- <div class="_num _num1">工单处理数 <span>100000+</span></div>
      <div class="_num _num2">资产管理数 <span>200000+</span></div>
      <div class="_num _num3">空间管理数 <span>6000+</span></div>
      <div class="_num _num4">设备接入数 <span>70000+</span></div>
      <div class="_num _num5">在线项目数 <span>10+</span></div> -->
        <div class="_btm">
          <ul class="_list">
            <li
              class="_item"
              v-for="item in imgList"
              :key="item.id"
              :style="{ backgroundImage: 'url(' + item.small + ')' }"
              @mouseenter="mouseEnter(item.id)"
              @mouseleave="mouseLeave"
              :class="active === item.id ? '_active' : ''"
            ></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="_m" v-else-if="$store.state.screenWidth <= 960">
      <div class="content">
        <div class="_header">
          <h5>建筑全生命期可视化管理平台</h5>
          <span>HBIM LVP</span>
        </div>
        <div class="_info">
          <ul class="_left">
            <li>以项目为核心</li>
            <li>连接项目各参建方</li>
            <li>共享项目数据</li>
            <li>即时沟通 高效协同</li>
          </ul>
          <div class="_right">
            <ul class="_left">
              <li>在线项目数<span>13+</span></li>
              <li>图纸管理数<span>3000+</span></li>
              <li>资料管理数<span>7000+</span></li>
            </ul>
            <ul class="_right">
              <li>模型管理数<span>400+</span></li>
              <li>任务处理数<span>1000+</span></li>
            </ul>
          </div>
          <a href="#/product/lvp" class="_btn">了解更多</a>
          <!-- <div class="_btn" @click="$router.push('/product/lvp')">了解更多</div> -->
        </div>
        <div class="_circle_bg">
          <div class="_bigimg_bg">
            <img :src="mActiveImg" alt="" />
          </div>
        </div>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in imgList" :key="item.id">
              <img :src="item.small" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import bg1 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg1.png";
// import bg2 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg2.png";
// import bg3 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg3.png";
// import bg4 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg4.png";
// import bg5 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg5.png";
// import sm1 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm1.png";
// import sm2 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm2.png";
// import sm3 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm3.png";
// import sm4 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm4.png";
// import sm5 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm5.png";
// import md1 from "../../assets/images/lvp/md1.png";
// import md2 from "../../assets/images/lvp/md2.png";
// import md3 from "../../assets/images/lvp/md3.png";
// import md4 from "../../assets/images/lvp/md4.png";
// import md5 from "../../assets/images/lvp/md5.png";
import Swiper from "swiper";
export default {
  data() {
    return {
      // bg1 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg1.png",
      // bg2 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg2.png",
      // bg3 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg3.png",
      // bg4 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg4.png",
      // bg5 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg5.png",
      // sm1 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm1.png",
      // sm2 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm2.png",
      // sm3 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm3.png",
      // sm4 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm4.png",
      // sm5 :"https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm5.png",
      imgList: [
        {
          id: 1,
          small: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm1.png",
          // middle: md1,
          big: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg1.png",
        },
        {
          id: 2,
          small: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm2.png",
          // middle: md2,
          big: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg2.png",
        },
        {
          id: 3,
          small: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm3.png",
          // middle: md3,
          big: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg3.png",
        },
        {
          id: 4,
          small: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm4.png",
          // middle: md4,
          big: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg4.png",
        },
        {
          id: 5,
          small: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/sm5.png",
          // middle: md5,
          big: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg5.png",
        },
      ],
      active: 1,
      activeImg: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg1.png",
      mActiveImg: "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp/bg1.png",
      timer: "",
    };
  },
  mounted() {
    const that = this;
    this.timer = setInterval(() => {
      this.active++;
      this.changeImage(this.active);
      if (this.active > 5) {
        this.active = 1;
        this.changeImage(this.active);
      }
    }, 3000);
    if (document.body.clientWidth <= 960) {
      this.$nextTick(() => {
        new Swiper(".mySwiper", {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          autoplay: {
            //自动开始
            delay: 3000, //时间间隔
            disableOnInteraction: false, //*手动操作轮播图后不会暂停*
          },
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          on: {
            transitionEnd: function () {
              // console.log(this.activeIndex, "this.activeIndex");
              that.mActiveImg = that.imgList[this.activeIndex - 3]
                ? that.imgList[this.activeIndex - 3].big
                : that.imgList[0].big;
            },
          },
        });
      });
    }
  },
  methods: {
    changeImage(id) {
      this.active = id;
      this.imgList.forEach((el) => {
        if (el.id === id) {
          this.activeImg = el.big;
        }
      });
    },
    mouseEnter(id) {
      clearInterval(this.timer);
      this.active = id;
      this.imgList.forEach((el) => {
        if (el.id === id) {
          this.activeImg = el.big;
        }
      });
    },
    mouseLeave() {
      this.timer = setInterval(() => {
        this.active++;
        this.changeImage(this.active);
        if (this.active > 5) {
          this.active = 1;
          this.changeImage(this.active);
        }
      }, 3000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
._lvp {
  width: 100%;
  overflow: hidden;
  ._p {
    height: 9.37rem;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_bg.png") no-repeat;
    background-size: cover;
    background-position: center;
    padding-top: 0.4rem;
    ._center {
      position: relative;
    }
    ._header {
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }
    ._des {
      width: 2.66rem;
      height: 2.76rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_des.png") no-repeat;
      background-position: center;
      background-size: contain;
      font-size: 0.16rem;
      color: #fff;
      margin-top: 0.63rem;
      ul {
        padding: 0.34rem 0 0 0.75rem;
        li {
          margin-bottom: 0.2rem;
          position: relative;
          &::before {
            position: absolute;
            top: 0;
            left: -0.25rem;
            content: "";
            display: block;
            width: 0.19rem;
            height: 0.19rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_circle.png") no-repeat;
            background-position: center;
            background-size: contain;
          }
        }
      }

      ._btn {
        width: 1rem;
        height: 0.32rem;
        line-height: 0.32rem;
        text-align: center;
        margin: 0 auto;
        background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
          linear-gradient(#3660aa, #3660aa);
        cursor: pointer;
      }
    }
    ._lvp_img_bg {
      position: absolute;
      top: 1.39rem;
      left: 50%;
      transform: translateX(-50%);
      width: 7rem;
      height: 4.15rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_img_bg.png") no-repeat;
      background-size: cover;
      background-position: center;
      ._img {
        width: 6.57rem;
        height: 3.7rem;
        margin: 0.19rem auto;
        transition: all 0.4s ease-in-out;
        background-size: contain;
      }
    }
    ._btm {
      position: absolute;
      top: 7rem;
      width: 100%;

      ._list {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 1.66rem;
        ._item {
          width: 2.39rem;
          height: 1.35rem;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          cursor: pointer;
          transition: all 0.4s ease-in-out;
        }
        ._active {
          width: 2.94rem;
          height: 1.66rem;
        }
      }
    }
    ._num {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 0.16rem;
      color: #fff;
      font-weight: bold;
      span {
        font-size: 0.2rem;
        font-style: italic;
        font-weight: bold;
        color: #ecc800;
        box-shadow: 0px 0.03rem 0.03rem 0px rgba(0, 18, 40, 0.48);
      }
    }
    ._num1 {
      top: 146%;
      left: 9%;
    }
    ._num2 {
      top: 210%;
      left: 23%;
    }
    ._num3 {
      top: 206%;
      left: 58%;
    }
    ._num4 {
      top: 155%;
      left: 85%;
    }
    ._num5 {
      top: 87%;
      left: 86%;
    }
  }
  ._m {
    position: relative;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_04.png") no-repeat;
    background-size: cover;
    background-position: center;
    .content {
      padding: 0.3rem 0.26rem 2.72rem;
    }
    ._header {
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }
    ._info {
      position: relative;
      width: 6.96rem;
      // height: 1.67rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_05.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      display: flex;
      padding: 0.51rem 0.36rem 0.3rem 0.47rem;
      > ._left {
        margin-right: 0.6rem;
        li {
          position: relative;
          font-size: 0.16rem;
          letter-spacing: 0.008rem;
          color: #ffffff;
          margin-bottom: 0.1rem;
          &::before {
            position: absolute;
            left: -0.2rem;
            top: 0;
            content: "";
            display: block;
            width: 0.17rem;
            height: 0.17rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_06.png") no-repeat;
            background-size: contain;
            background-position: center;
          }
        }
      }
      > ._right {
        display: flex;
        ul {
          li {
            font-size: 0.16rem;
            letter-spacing: 0rem;
            color: #ffffff;
            margin-bottom: 0.2rem;
            span {
              font-size: 0.2rem;
              font-weight: bold;
              font-style: italic;
              font-stretch: normal;
              color: #ecc800;
            }
          }
        }
        ._left {
          margin-right: 0.2rem;
        }
      }
      ._btn {
        position: absolute;
        right: 0.3rem;
        bottom: 0.25rem;
        width: 1.01rem;
        height: 0.33rem;
        line-height: 0.33rem;
        background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
          linear-gradient(#3660aa, #3660aa);
        background-blend-mode: normal, normal;
        border-radius: 0.02rem;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.16rem;
        text-align: center;
      }
    }
    ._circle_bg {
      position: relative;
      width: 100%;
      height: 3.84rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_07.png") no-repeat;
      background-size: contain;
      background-position: center;
      margin-top: 1.45rem;
      ._bigimg_bg {
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 6.51rem;
        height: 3.87rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_08.png") no-repeat;
        background-size: contain;
        background-position: center;
        text-align: center;
        img {
          width: 6.11rem;
          height: 3.45rem;
          margin-top: 0.2rem;
        }
      }
    }
    .mySwiper {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: -3.5rem;
      left: 0;
      .swiper-wrapper {
        .swiper-slide {
          text-align: center;
          font-size: 18px;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          transition: 300ms;
          transform: scale(0.8);
        }
        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
          z-index: 99;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Index/Lvp.vue